import AccordionBody from '@components/Accordion/AccordionBody';
import AccordionCollapse from '@components/Accordion/AccordionCollapse';
import AccordionHeader from '@components/Accordion/AccordionHeader';
import AccordionItem from '@components/Accordion/AccordionItem';
import Info from '@components/Info';
import { List, ListItem } from '@components/List';
import Section, { SectionHeadline } from '@components/Section';
import Container from '@components/UI/Container';
import Icon from '@components/UI/Icon';
import Heading from '@components/UI/Typography/Heading';
import Paragraph from '@components/UI/Typography/Paragraph';
import RenderIf from '@utils/renderIf';

import React, { useState } from 'react';

import Data from './data';

const Faq = () => {

    const { faq } = Data;

    const [collapsed, setCollapse] = useState(false)

    const handleActiveClick = (id) => {
        setCollapse(id !== collapsed && id);
    }

    return (
        <Section
            mods={ {
                home: true,
                narrow: true,
            } }
        >
            <Container>
                <SectionHeadline
                    mods={ { center: true, w: 75 } }
                    gap={ 4 }
                    className={ 'relative lg:w-[75%]' }
                >
                    <Heading
                        tag='h2'
                    >
                        Frequently Asked Questions
                    </Heading>
                </SectionHeadline>
                <div className='flex flex-col gap-y-4 max-w-[720px] mx-auto'>
                    { faq.map(({ id, title, desc, list }) => (
                        <AccordionItem
                            key={ id }
                            className='!bg-transparent px-0 py-0 border-none'
                        >
                            <AccordionHeader
                                className='!px-0 !pt-0 !pb-0 items-center !gap-0 !justify-start'
                                onClick={ () => handleActiveClick(id) }
                            >
                                <Icon
                                    name={ collapsed === id ? 'minus' : 'plus' }
                                    size={ 40 }
                                    color='violet-700'
                                    className='pr-4'
                                />
                                <Info
                                    mods={ { row: true } }
                                >
                                    <Heading
                                        tag='h5'
                                    >
                                        { title }
                                    </Heading>
                                </Info>
                            </AccordionHeader>

                            <AccordionCollapse
                                collapsed={ collapsed === id || false }
                            >
                                <AccordionBody className='!pb-0 pt-2 !pr-10 !pl-14 text-neutral-700'>
                                    { desc && <Paragraph
                                        mods={{lg: true}}
                                        color='neutral_700'
                                    >
                                        { desc }
                                    </Paragraph> }
                                    { list && <List
                                        gap={ 2 }
                                        className='mt-4'
                                    >
                                        { list.map((desc, index) =>
                                            <ListItem
                                                key={ index }
                                            >

                                                <Icon
                                                    name={ 'square-rounded' }
                                                    color={ 'violet-700' }
                                                    size={ 24 }
                                                />

                                                <Paragraph
                                                    tag='p'
                                                    size='lg-custom'
                                                    color='neutral_700'
                                                >
                                                    { desc }
                                                </Paragraph>
                                            </ListItem>
                                        ) }
                                    </List> }
                                </AccordionBody>
                            </AccordionCollapse>
                        </AccordionItem>
                    )) }
        </div>
            </Container>
        </Section>
    )
}


export default Faq;
